<template>
	<div class="leftList">
		<div class="top">
			<div class="one" v-for="item in list" >
				<div class="title">
					<p class="lf">{{item.name}}</p>
					<p class="more" @click="more()">更多</p>
				</div>
				<div class="centeen" @click="detail((item.article)[0].id)">
					<h3>{{(item.article)[0].title}}</h3>
					<div class="share">
						<div class="share_icon">
							<img src="../assets/home_2.png" alt="">
							<p>新闻</p>
						</div>
						<span>{{(item.article)[0].addtime}}</span>
					</div>
					<img class="img" :src="(item.article)[0].image" alt="">
				</div>
			</div>
		</div>
		<div :class="['zhan',_top?'zhan2':'zhan3']" @click="mores" v-if="bools"></div>
		<div class="center" v-if="show">
			<div class="one">
				<div class="title">
					<p class="lf">重点会展</p>
					<p class="more">更多</p>
				</div>
				<div class="centeen">
					<img class="img" src="../assets/ceshi3.png" alt="">
					<h3>都来“教”恒瑞做事了，恒瑞BD业务究竟差在哪里？</h3>
					<div class="time">
						<img src="../assets/time.png" alt="">
						<span>时间：2021-12-24 至 2021-12-24 </span>
					</div>
					<div class="address">
						<img src="../assets/address.png" alt="">
						<span>地点：南京国际博览会议中心</span>
					</div>
					
				</div>
				<div class="list">
					<ul class="titles">
						<li>会议</li>
						<li>展览</li>
					</ul>
					<ul class="huiList">
						<li>2021中国医药企业家科学家投资家大会</li>
						<li>2021中国医药企业家科学家投资家大会</li>
						<li>2021中国医药企业家科学家投资家大会</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="bottoms" v-if="show">
			<img src="../assets/ceshi.png" alt="">
			<div class="dibu">
				<div class="mask"></div>
				<p>数字粤智康  助力医药全产业链转化!医药…</p>
			</div>
		</div>
		<div class="hot" v-if="bools">
			<p class="title">热门药物查询</p>
			<div class="row">
				<img class="row1" src="../assets/ceshi8.png" alt="">
				<div class="row2"></div>
				<div class="row3"></div>
				<div class="row4"></div>
				<div class="row5"></div>
				<div class="row6"></div>
				<img class="row7" src="../assets/ceshi8.png" alt="">
				<div class="row8"></div>
				<div class="row9"></div>
				<div class="row10"></div>
				<div class="row11"></div>
				<img class="row12" src="../assets/ceshi8.png" alt="">
			</div>
		</div>
	</div>
</template>

<script>
	// 引入axios
	import axios from 'axios';
	// 引入端口配置文件
	import API_LIST from '@/list.config.js';
	import qs from 'qs'
	
	export default {
		name: "HelloWorld",
		props: {
			bool:Boolean,
			num:Number
		},
		data() {
			return {
				list:[],
				dataList:[],
				show:false,
				_top:this.bool,
				bools:this.bool
			}
	
		},
		watch: {
	
	
		},
		computed:{
			list(){
				if(this._top){
					return this.dataList.slice(0,2)
				}else{
					return this.dataList
				}
			}
		},
		created() {
			
		},
		mounted() {
			console.log(API_LIST.sidebar)
			const that = this;
			axios.post(API_LIST.sidebar, {}, {
					headers: {
						// 'Content-Type': 'application/x-www-form-urlencoded'
						'Content-Type': 'application/json'
					} //加上这个x
				})
				.then(_d => {
					console.log(_d.data)
					if (_d.data.status == 200) {
						// console.log(_d)
						that.dataList = _d.data.list
						
						
					} else if (_d.data.status == 409) {
						
					}
					
								
				})
				.catch(function(error) {
					console.log(error);
				});
			window.addEventListener("scroll", this.handleScroll);
		},
		methods: {
			
			detail(_id) {
				this.$router.push({
					path: '/Detail',
					query:{
						id:_id
					}
				})
			},
			more(){
				this.$router.push({
					path: '/List',
					query:{
						id:2
					}
				})
			},
			handleScroll() {
				let scrollY = window.pageYOffset ||
					document.documentElement.scrollTop ||
					document.body.scrollTop;
				let scrollObj = document.querySelector(".leftList");
				//scrollObj 这个是下图右边答题卡的div
				// console.log(scrollY)
				if (scrollY > this.num) {
					//这个358就是上面的距离
					scrollObj.style.position = "fixed";
					scrollObj.style.zIndex = 1000000;
					scrollObj.style.right = "110px";
					scrollObj.style.bottom = 200+'px';
				} else {
					scrollObj.style.position = "static";
					scrollObj.style.marginTop = "0";
				}
			},
			mores(){
				this._top = !this._top;
			}
		},
		destroyed() {
			//销毁监听
			console.log(333)
			window.removeEventListener("scroll", this.handleScroll);
		},
	};
</script>

<style scoped="scoped" lang="scss">
	.leftList{
		display: flex;
		flex-direction: column;
		width: 330px;
		.top,
		.center{
			display: flex;
			flex-direction: column;
			.one{
				display: flex;
				flex-direction: column;
				background-color: #fff;
				box-sizing: border-box;
				padding: 10px;
				margin: 0 0 10px 0;
				.title{
					display: flex;
					flex-direction: row;
					justify-content: space-between;
					align-items: center;
					border-bottom: 1px solid #ccc;
					padding: 0 0 5px 0;
					.lf{
						font-size: 16px;
						font-family: MicrosoftYaHei;
						color: #39A49B;
					}
					.more{
						font-size: 10px;
						padding: 0 15px 0 0;
						font-family: MicrosoftYaHei;
						color: #39A49B;
						position: relative;
					}
					.more::before{
						content: '';
						width: 4px;
						height: 4px;
						position: absolute;
						right: 0;
						top: 0;
						bottom: 0;
						margin: auto;
						transform: rotate(-45deg);
						border-right: 1px solid #39A49B;
						border-bottom: 1px solid #39A49B;
					}
					.more::after{
						content: '';
						width: 4px;
						height: 4px;
						position: absolute;
						right: 5px;
						top: 0;
						bottom: 0;
						margin: auto;
						transform: rotate(-45deg);
						border-right: 1px solid #39A49B;
						border-bottom: 1px solid #39A49B;
					}
				}
				.centeen{
					margin: 10px 0 0 10px;
					text-align: left;
					h3{
						font-size: 12px;
					}
					.share{
						display: flex;
						flex-direction: row;
						align-items: center;
						margin-bottom: 5px;
						.share_icon{
							display: flex;
							flex-direction: row;
							align-items: center;
							
							img{
								margin: 0 5px 0 0;
								
							}
							p{
								font-size: 10px;
								color: #999999;
							}
							
							
						}
						span{
							font-size: 10px;
							color: #999999;
							margin: 0 0 0 60px;
						}
					}
					.img{
						width: 100%;
						height: 134px;
					}
					.time,
					.address{
						display: flex;
						flex-direction: row;
						align-items: center;
						font-size: 12px;
						color: #999999;
						margin: 5px 0 0 0;
						img{
							margin: 0 5px 0 0;
							width: 11px;
							// height: 13px;
						}
					}
				}
				.list{
					margin: 15px 0 0 0;
					border-top: 1px dotted #efefef;
					display: flex;
					flex-direction: column;
					.titles{
						display: flex;
						flex-direction: row;
						justify-content: space-around;
						margin: 10px 0;
						li{
							font-size: 12px;
							font-family: MicrosoftYaHei;
							color: #39A49B;
						}
					}
					.huiList{
						text-align: left;
						margin: 0 0 0 10px;
						li{
							margin: 3px 0 0 0;
							font-size: 12px;
							font-family: MicrosoftYaHei;
							color: #333333;
						}
					}
				}
				
			}
			.one:hover{
				cursor: pointer;
			}
		}
		.bottoms{
			position: relative;
			img{
				width: 100%;
				
			}
			.dibu{
				position: absolute;
				bottom: 0;
				left: 0;
				width: 100%;
				.mask{
					position: absolute;
					bottom: 0;
					left: 0;
					width: 100%;
					background-color: #000;
					opacity: 0.3;
					height:30px;
				}
				p{
					position: absolute;
					bottom: 5px;
					left: 0;
					right: 0;
					margin: auto;
					z-index: 10;
					width: 100%;
					font-size: 16px;
					font-family: MicrosoftYaHei;
					color: #FFFFFF;
					width: 300px;
				}
			}
		}
		.zhan{
			width: 200px;
			height: 35px;
			background-color: #aaa;
			margin: 0 auto;
			overflow: hidden;
			position: relative;
		}
		.zhan2::before{
			content: '';
			width: 10px;
			height: 60px;
			background-color: #fff;
			// border-left: 10px solid #fff;
			position: absolute;
			left: 70px;
			// right: 0;
			top: -12px;
			transform: rotate(-70deg);
		}
		.zhan2::after{
			content: '';
			width: 10px;
			height: 60px;
			background-color: #fff;
			// border-left: 10px solid #fff;
			position: absolute;
			left: 123px;
			// right: 0;
			top: -12px;
			transform: rotate(70deg);
		}
		.zhan3::before{
			content: '';
			width: 10px;
			height: 60px;
			background-color: #fff;
			// border-left: 10px solid #fff;
			position: absolute;
			left: 70px;
			// right: 0;
			top: -12px;
			transform: rotate(70deg);
		}
		.zhan3::after{
			content: '';
			width: 10px;
			height: 60px;
			background-color: #fff;
			// border-left: 10px solid #fff;
			position: absolute;
			left: 123px;
			// right: 0;
			top: -12px;
			transform: rotate(-70deg);
		}
		.hot{
			width: 249px;
			display: flex;
			flex-direction: column;
			margin: 30px 0 0 0;
			.title{
				font-size: 15px;
				margin: 0 0 20px 0;
				color: #3A3A3A;
			}
			.row{
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				justify-content: space-between;
				height: 370px;
				.row1{
					width: 173px;
					height: 66px;
				}
				.row2{
					width: 66px;
					height: 66px;
					background-color: #E2F4D8;
				}
				.row3{
					width: 66px;
					height: 66px;
					background-color: #D8F1F4;
				}
				.row4{
					width: 66px;
					height: 66px;
					background-color: #F4EBD8;
				}
				.row5{
					width: 101px;
					height: 66px;
					background-color: #D8F4E7;
				}
				.row6{
					width: 66px;
					height: 66px;
					background-color: #E2F4D8;
				}
				.row7{
					width: 173px;
					height: 66px;
				}
				.row8{
					width: 101px;
					height: 66px;
					background-color: #D8F4E7;
				}
				.row9{
					width: 66px;
					height: 66px;
					background-color: #D8F1F4;
				}
				.row10{
					width: 66px;
					height: 66px;
					background-color: #F4EBD8;
				}
				.row11{
					width: 66px;
					height: 66px;
					background-color: #E2F4D8;
				}
				.row12{
					width: 173px;
					height: 66px;
				}
				
			}
		}
	}
</style>
